// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  characterId: __t.u64().primaryKey().name("character_id"),
  userId: __t.u64().name("user_id"),
  identity: __t.identity(),
  regionId: __t.u64().name("region_id"),
  treeId: __t.u64().name("tree_id"),
  segmentId: __t.u64().name("segment_id"),
  s: __t.f64(),
  theta: __t.f64(),
  r: __t.f64(),
  poseUpdatedAt: __t.timestamp().name("pose_updated_at"),
  spawnedAt: __t.timestamp().name("spawned_at"),
});
